/**
 * Plain-text excerpt of CMS HTML for meta descriptions and card perexes.
 *
 * Unlike core `getTextFromHTML`, headings are dropped (a page would otherwise open with its own
 * title: "Doprava Objednané zboží…"), tags become spaces so blocks don't run together, and the
 * text is cut after the last whole word that fits.
 */
export function htmlExcerpt(html: string | null | undefined, maxLength = 160) {
  const text = (html ?? '')
    .replace(/<h[1-6]\b[^>]*>[\s\S]*?<\/h[1-6]>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/\s+/g, ' ')
    .trim();

  if (text.length <= maxLength) return text;

  const cut = text.slice(0, maxLength + 1);
  const lastSpace = cut.lastIndexOf(' ');
  const words = lastSpace > 0 ? cut.slice(0, lastSpace) : text.slice(0, maxLength);
  return `${words.replace(/[\s,;:–-]+$/, '')}…`;
}
